define(['underscore'], (_) => {

    /**
     * Server exception
     *
     * @param error
     * @constructor
     */
    function JsonRPCException(data) {

        if (data) {
            //copy data if any present
            _.extend(this, data);
        }
    }

    return JsonRPCException;

});


// WEBPACK FOOTER //
// ./app/customer/js/src/edge/platform/base/JsonRPCException.js